module.exports = __webpack_public_path__ + "img/item011.e560eedc.png";